import React from 'react';
import { useServiceClient } from 'common';
import { useMutation } from 'react-query';
import { MyAppsEndPoints, MyAppsQueryKey } from './query-enums';

interface ICreateMobileBuildPayload {
    AppBuildVersion: string,
    AppFileDescription: string,
    AppFileDisplayName: string,
    AppFileName: string,
    AppId: string,
    AppName: string,
    AppType: string,
    AppVersion: string,
    BuildRequestedDate: string,
    BuildRequestedBy: string,
    IsSystemAutorequested: string,
    NoOfTimesDownloaded: string,
    BuildStatus: number
}

interface ICreateMobileBuildResposne {
    CreateMobileBuildResult: {
        AppBuildVersion: string,
        AppDownloadURL: string | null,
        AppFileDescription: string,
        AppFileDisplayName: string,
        AppFileName: string,
        AppId: string,
        AppName: string,
        AppType: string,
        AppVersion: string,
        BuildFailedErrorMessage: null,
        BuildRequestDetails: null,
        BuildRequestId: string,
        BuildRequestedBy: string,
        BuildRequestedDate: string,
        BuildStatus: number,
        IsSystemAutorequested: string,
        NoOfTimesDownloaded: string
    }
}

export const useCreateMobileBuildQuery = () => {
    const { postData } = useServiceClient();
    const createMobileBuild = React.useCallback((payload: ICreateMobileBuildPayload) => postData(MyAppsEndPoints.CREATE_MOBILE_BUILD, payload).then<ICreateMobileBuildResposne>((res) => res.json()), [postData]);
    return useMutation(MyAppsQueryKey.CREATE_MOBILE_BUILD, createMobileBuild);
};
